import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const styles = StyleSheet.create({
  VFScreenStyle: {
    alignItems: 'center',
  },
  contentContainer: {
    paddingHorizontal: 16.3,
  },
  subTitleStyle: {
    fontSize: 24,
    marginVertical: 16.3,
    ...Fonts.type.bold,
    marginTop: 32,
  },
  permissionCardView: (theme, isLastSingle) => ({
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4.65,
    elevation: 8,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    marginBottom: isLastSingle ? 32 : 16,
  }),

  permissionDescriptionStyle: theme => ({
    marginEnd: undefined,
    color: theme.colors.text.primary,
    marginTop: 16,
    marginBottom: 10,
  }),
  singlePermissionItemStyle: {
    borderBottomWidth: 0,
    marginHorizontal: 16,
  },
  advancedPermissionsChildStyle: theme => ({
    marginStart: 50,
    paddingStart: 0,
    borderTopWidth: 1,
    borderTopColor: theme.colors.horizontalLineColor,
    borderBottomWidth: 0,
  }),
  advancedPermissionsChildTextStyle: theme => ({
    marginStart: 8,
    marginEnd: undefined,
    color: theme.colors.text.primary,
    marginTop: 16,
  }),
  learnMoreDescriptionContainer: {
    marginBottom: 11,
  },
});

export default styles;
